import type { Props } from './Svg'
import { Svg } from './Svg'

export function CrossIcon(props: Props) {
  return (
    <Svg width="10" height="10" fill="none" strokeWidth="2" {...props}>
      <path d="m1 1 8 8M9 1 1 9" />
    </Svg>
  )
}
